import {
  ExploreTool,
  ExploreToolsConfig,
} from '@backstage/plugin-explore-react';

export class ExploreToolsClient implements ExploreToolsConfig {
  async getTools(): Promise<ExploreTool[]> {
    return [
      {
        title: 'Cost Insights',
        description: 'Insights into cloud costs for your organization.',
        url: '/cost-insights',
        image: '/images/AWS.png',
        tags: ['cloud', 'finops'],
      },
      {
        title: 'OpsGenie',
        description:
          'Incident management platform, manages alerting via on-call schedules and escalations.',
        url: '/opsgenie',
        image: '/images/opsgenie-logo.webp',
        tags: ['monitoring', 'opsgenie', 'alerting'],
      },
      {
        title: 'Tech Radar',
        description:
          'Tech Radar is a list of technologies, complemented by an assessment result, called ring assignment.',
        url: '/tech-radar',
        image: '/images/tech-radar.png',
        tags: ['standards', 'landscape'],
      },
    ];
  }
}
